import { PrismCard, PrismMessage } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import RegisterErrorCardHeaderTitle from 'frontend-login/components/register-error/card-header-title';
import styles from 'frontend-login/templates/register-email-sent.module.css';

<template>
  <main class={{styles.container-main}}>
    <PrismCard>
      <:header as |Header|>
        <Header.title>
          <RegisterErrorCardHeaderTitle />
        </Header.title>
      </:header>
      <:content>
        <PrismMessage
          @description={{t "password.reset_email_sent.description"}}
          @illustration="100x100_success"
          @title={{t "password.reset_email_sent.title"}}
        />
      </:content>
    </PrismCard>
  </main>
</template>
